import { IStyle, Stack } from '@fluentui/react';
import { Loader, useClassNames } from '@h2oai/ui-kit';
import React from 'react';

import {
  currentUserGlobalMLOpsActions,
  PermissionsResolver,
} from '../../components/PermissionsResolver/PermissionsResolver';
import { stackStylesPage } from '../../themes/themes';
import { ClassNamesFromIStyles } from '../../utils/models';
import type { MLOpsUserActionType } from './userActions';

interface INavigationWrapperStyles {
  container: IStyle;
  stack: IStyle;
  noPermissions: IStyle;
}

const navigationWrapperStyles = (): Partial<INavigationWrapperStyles> => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0,
  },
  noPermissions: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
});

export type NavigationWrapperNoMagicProps = {
  children: React.ReactNode;
  requiredWorkspacePermissions?: MLOpsUserActionType[];
  requiredMLOpsGlobalPermissions?: MLOpsUserActionType[];
};

export const NavigationWrapperNoMagic = (props: NavigationWrapperNoMagicProps) => {
  const { requiredMLOpsGlobalPermissions, requiredWorkspacePermissions } = props;
  const classNames = useClassNames<INavigationWrapperStyles, ClassNamesFromIStyles<INavigationWrapperStyles>>(
    'navigationWrapper',
    navigationWrapperStyles
  );

  return (
    <div className={classNames.container}>
      <Stack styles={stackStylesPage} className={classNames.stack}>
        <PermissionsResolver
          actions={[
            ...(!requiredMLOpsGlobalPermissions ? [] : currentUserGlobalMLOpsActions(requiredMLOpsGlobalPermissions)),
            ...(requiredWorkspacePermissions || []),
          ]}
        >
          {({ allAllowed, loading }) => {
            return loading || !allAllowed ? (
              <div className={classNames.noPermissions}>
                {loading ? (
                  <Loader label="Just a moment, checking your permissions..." />
                ) : (
                  `You have no access to this page.\nAsk the workspace owner to grant you permissions.`
                )}
              </div>
            ) : (
              props.children
            );
          }}
        </PermissionsResolver>
      </Stack>
    </div>
  );
};
